import type { Dispatch } from 'redux';
import { setIntroOpen } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/command/onboarding';
import { toggleToolBar } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/top/title-bar/tool-bar/actions';

import type { DispatchProps } from './types';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	dispatch: Dispatch<{
		type: string;
	}>,
): DispatchProps => ({
	showOnboarding: () => {
		dispatch(setIntroOpen(true));
	},
	toggleToolBar: () => {
		dispatch(toggleToolBar());
	},
});
